module.exports = __webpack_public_path__ + "img/non planproduct.6c0d55a2.svg";